import React, { useState, useRef } from "react";
import GoogleTranslate from "../components/GoogleTranslate";

const SettingsPopup = ({
    isOpen,
    onClose,
    selectedIcon,
    setSelectedIcon,
    bgColor,
    setBgColor,
    uploadedImage,
    setUploadedImage,
    studentName,
}) => {
    const [activeTab, setActiveTab] = useState("Profile");
    const fileInputRef = useRef(null);

    const handleSave = () => {
        localStorage.setItem("profileIcon", selectedIcon);
        localStorage.setItem("bgcolor", bgColor);
        onClose();
    };

    const resetSelections = () => {
        const initials = generateInitials(studentName);
        setSelectedIcon(initials);

        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        bgColor = "#ffffff";
        setBgColor(bgColor);
        setUploadedImage(null);
    };

    if (!isOpen) return null;

    const generateInitials = (name) => {
        if (!name) return "";
        const nameParts = name.split(" ");
        const initials = nameParts
            .map((part) => part.charAt(0).toUpperCase())
            .join("");
        return initials.slice(0, 2);
    };

    const initials = generateInitials(studentName);

    return (
        <div
            style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "black",
            }}
        >
            <div
                style={{
                    backgroundColor: "white",
                    width: "60%",
                    height: "70%",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "8px",
                    overflow: "hidden",
                }}
            >
                <div
                    style={{
                        textAlign: "center",
                        color: "#2D4D93",
                        padding: "5px",
                        fontSize: "20px",
                        fontWeight: "bold",
                        borderBottom: "1px solid #2D4D93"
                    }}
                >
                    Settings
                </div>

                <div style={{ display: "flex", height: "100%" }}>
                    <div
                        style={{
                            width: "15%",
                            backgroundColor: "white",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            padding: "10px 0",
                        }}
                    >
                        {/* {["Profile", "Translate", "Color"].map((tab) => ( */}
                        {["Profile", "Translate"].map((tab) => (
                          <button
                                key={tab}
                                onClick={() => setActiveTab(tab)}
                                style={{
                                    background:
                                        activeTab === tab ? "linear-gradient(to right, rgb(46 89 188), rgb(255 255 255))" : "transparent",
                                    border: "none",
                                    padding: "10px 15px",
                                    textAlign: "left",
                                    cursor: "pointer",
                                    width: "100%",
                                    fontSize: "16px",
                                    color: activeTab === tab ? "white" : "black",
                                }}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>

                    <div style={{ flex: 1, padding: "10px 20px", overflowY: "auto", marginBottom: "40px" }}>
                        {activeTab === "Profile" && (
                            <div style={{ textAlign: "center" }}>
                                <h5 style={{ padding: "15px" }}>Customize Profile</h5>

                                <div translate="no"
                                    style={{
                                        display: "flex",
                                        gap: "10px",
                                        marginBottom: "20px",
                                        flexWrap: "wrap",
                                        justifyContent: "center",
                                    }}
                                >
                                    <div
                                        onClick={() => setSelectedIcon(null)}
                                        style={{
                                            fontSize: "30px",
                                            cursor: "pointer",
                                            padding: "10px",
                                            border:
                                                selectedIcon === null ? "2px solid #2D4D93" : "none",
                                            borderRadius: "5px",
                                            backgroundColor:
                                                selectedIcon === null
                                                    ? "#e0e0e0"
                                                    : "transparent",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "60px",
                                            height: "65px",
                                            display: "none"
                                        }}
                                    >
                                        🚫
                                    </div>

                                    <div
                                        onClick={() => setSelectedIcon(initials)}
                                        style={{
                                            fontSize: "28px",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            border:
                                                selectedIcon === initials
                                                    ? "2px solid #2D4D93"
                                                    : "none",
                                            borderRadius: "5px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "60px",
                                            height: "65px",
                                            color: "#2D4D93"
                                        }}
                                    >
                                        {initials}
                                    </div>

                                    {[
                                        "👦",
                                        "👧",
                                        "😄",
                                        "😊",
                                        "👤",
                                        "🌸",
                                        "🎩",
                                        "⭐",
                                        "⚽",
                                        "📚",
                                        "🚄",
                                        "🚀",
                                        "🚁",
                                        "🌲",
                                        "🐴",
                                    ].map((icon) => (
                                        <div
                                            key={icon}
                                            onClick={() => setSelectedIcon(icon)}
                                            style={{
                                                fontSize: "30px",
                                                cursor: "pointer",
                                                padding: "10px",
                                                border:
                                                    selectedIcon === icon
                                                        ? "2px solid #2D4D93"
                                                        : "none",
                                                borderRadius: "5px",
                                            }}
                                        >
                                            {icon}
                                        </div>
                                    ))}
                                </div>

                                <div style={{ marginBottom: "20px" }}>
                                    <label htmlFor="color-picker" style={{ marginRight: "10px" }}>
                                        Choose a Background Color:
                                    </label>
                                    <input
                                        type="color"
                                        id="color-picker"
                                        value={bgColor}
                                        onChange={(e) => setBgColor(e.target.value)}
                                    />
                                </div>

                                <div style={{ padding: "50px 0 10px 0" }}>
                                    <button
                                        onClick={resetSelections}
                                        style={{
                                            backgroundColor: "#f44336",
                                            color: "white",
                                            border: "none",
                                            padding: "10px 20px",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Reset
                                    </button>

                                    <button
                                        onClick={handleSave}
                                        style={{
                                            backgroundColor: "#4CAF50",
                                            color: "white",
                                            border: "none",
                                            padding: "10px 20px",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                            marginLeft: "15px"
                                        }}
                                    >
                                        Save
                                    </button>

                                    <button
                                        onClick={onClose}
                                        style={{
                                            backgroundColor: "#4CAF50",
                                            color: "white",
                                            border: "none",
                                            padding: "10px 20px",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                            marginLeft: "15px"
                                        }}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        )}

                        {activeTab === "Color" && (
                            <div>
                                <h6>Color Content</h6>
                                <p>This is a placeholder for the second tab.</p>
                            </div>
                        )}

                        {activeTab === "Translate" && (
                            <div style={{ textAlign: "center" }}>
                                <div style={{ textAlign: "center" }}>
                                    <h5>Translate Content</h5>
                                    <div className="translate-container">
                                        <GoogleTranslate />
                                    </div>
                                </div>
                                <button
                                    onClick={onClose}
                                    style={{
                                        backgroundColor: "#4CAF50",
                                        color: "white",
                                        border: "none",
                                        padding: "10px 20px",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                        marginTop: "25%"
                                    }}
                                >
                                    Close
                                </button>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettingsPopup;
